import type { FooterLinks, LinkSegments } from '$lib/components/seo/types';
import type { AvailableLanguageTag } from '$paraglide/runtime';
import { segments2route } from '$lib/components/seo/linkSegments';
import * as m from '$paraglide/messages';

export function getReturnRouteLinks(returnRouteTitle: string, lang: AvailableLanguageTag, departureSegments?: LinkSegments, arrivalSegments?: LinkSegments): FooterLinks | undefined {
	if (!departureSegments || !arrivalSegments) {
		return undefined;
	}

	return {
		label: returnRouteTitle,
		links: [
			{
				href: segments2route(arrivalSegments, departureSegments, lang),
				label: `${m.search_tools__button__aria_label({}, { languageTag: lang })} ${arrivalSegments.at(-1)?.label} ${departureSegments.at(-1)?.label}`,
			},
		],
	};
}
